import React from "react"
import SEO from "../components/SEO"
import MenuPage from "../features/menu"
import { WEBSITE } from "../constants"

const Menu: React.FC = () => {
  return (
    <>
      <SEO
        title={`Thực Đơn | ${WEBSITE.TITLE}`}
        description="Khám phá thực đơn Thiền Trúc với thức uống thảo mộc, trà và cà phê nguyên bản. Vị ngon lành mạnh cho mỗi khoảnh khắc."
        keywords="Thiền Trúc menu, thực đơn Thiền Trúc, trà, cà phê, thảo mộc, đồ uống lành mạnh"
      />
      <div className="px-4 py-6 sm:px-8 sm:py-8 lg:px-16 lg:py-12">
        <MenuPage />
      </div>
    </>
  )
}

export default Menu
